import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// El reCAPTCHA de Firebase (iframe de origen cruzado) genera un "Script error."
// que dispara el overlay rojo de react-error-overlay y tapa toda la UI.
// Lo eliminamos SOLO cuando contiene ese ruido; los errores reales siguen visibles.
const removeNoisyOverlay = () => {
  const iframes = document.querySelectorAll("iframe");
  iframes.forEach((f) => {
    try {
      const doc = f.contentDocument;
      if (!doc) return;
      const text = doc.body ? doc.body.innerText : "";
      if (/Script error\.?/.test(text) || /recaptcha|gstatic\.com/.test(text)) {
        f.remove();
      }
    } catch (e) {
      // iframe de origen cruzado (no es el overlay): ignorar
    }
  });
  // react-error-overlay también puede renderizar en un div dedicado
  const divs = document.querySelectorAll("body > div");
  divs.forEach((d) => {
    const text = d.innerText || "";
    if (text.includes("Uncaught runtime errors") && /Script error\.?/.test(text)) {
      d.remove();
    }
  });
};

const overlayObserver = new MutationObserver(() => removeNoisyOverlay());
overlayObserver.observe(document.documentElement, { childList: true, subtree: true });

// Defensa adicional: evitar que el evento "Script error." propague al overlay.
window.addEventListener(
  "error",
  (e) => {
    const m = String(e?.message || "");
    const f = String(e?.filename || "");
    if (m.startsWith("Script error") || f.includes("recaptcha") || f.includes("gstatic.com")) {
      e.stopImmediatePropagation();
      e.preventDefault();
      setTimeout(removeNoisyOverlay, 0);
    }
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
